import { Controller } from "@hotwired/stimulus"
import Swiper from 'swiper'
import { Pagination, A11y, Autoplay } from 'swiper/modules'

export default class extends Controller {
    static targets = ["root", "prevBtn", "nextBtn", "pagination", "wrapper"]
    static values = {
        singly: Boolean,
        autoplay: Boolean,
        xsSlidesPerView: Number,
    }

    connect() {
        const configs = {
            modules: [A11y],
            slidesPerView: 1,
            spaceBetween: 10,
            on: {
                afterInit: () => {
                    this.nextBtnTarget.setAttribute('aria-controls', this.wrapperTarget.getAttribute('id'))
                    this.prevBtnTarget.setAttribute('aria-controls', this.wrapperTarget.getAttribute('id'))

                },
                reachEnd: () => {
                    this.nextBtnTarget.classList.replace('stroke-primary-950', 'stroke-gray-300')
                    this.nextBtnTarget.classList.replace('cursor-pointer', 'cursor-not-allowed')
                    this.nextBtnTarget.setAttribute('aria-disabled', 'true')
                },
                reachBeginning: () => {
                    this.prevBtnTarget.classList.replace('stroke-primary-950', 'stroke-gray-300')
                    this.prevBtnTarget.classList.replace('cursor-pointer', 'cursor-not-allowed')
                    this.prevBtnTarget.setAttribute('aria-disabled', 'true')
                },
                slideChange: () => {
                    if (!this.swiper.isBeginning) {
                        this.prevBtnTarget.classList.replace('stroke-gray-300', 'stroke-primary-950')
                        this.prevBtnTarget.classList.replace('cursor-not-allowed', 'cursor-pointer')
                        this.prevBtnTarget.setAttribute('aria-disabled', 'false')
                    }

                    if (!this.swiper.isEnd) {
                        this.nextBtnTarget.classList.replace('stroke-gray-300', 'stroke-primary-950')
                        this.nextBtnTarget.classList.replace('cursor-not-allowed', 'cursor-pointer')
                        this.nextBtnTarget.setAttribute('aria-disabled', 'false')
                    }
                }
            }
        }

        if (this.hasPaginationTarget) {
            configs.pagination = {
                el: this.paginationTarget,
                clickable: true,
            }

            configs.modules.push(Pagination)
        }

        if (this.autoplayValue) {
            configs.autoplay = {
                pauseOnMouseEnter: true,
            };

            configs.modules.push(Autoplay)
        }

        if (!this.singlyValue) {
            configs.breakpoints = {
                480: {
                    slidesPerView: this.xsSlidesPerViewValue || 2,
                    spaceBetween: 20,
                },
                576: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                },
                768: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                },
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                },
            }
        }

        this.swiper = new Swiper(this.rootTarget, configs)
    }

    nextSlide() {
        this.swiper.slideNext()
    }

    prevSlide() {
        this.swiper.slidePrev()
    }
}